// extracted by mini-css-extract-plugin
export default {"atlas":"index_atlas_NWwmn","atlasPic":"index_atlasPic_O4Pry","atlasItem":"index_atlasItem_yZpJn","atlasItemPic":"index_atlasItemPic_5eI-w","atlasNum":"index_atlasNum_1k5XC"};